// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3103l","colBig":"styles_colBig__dGlej","colSmall":"styles_colSmall__2WJo6"};